<template>
  <div class="mx-3 mt-2">
    <div class="row gy-2">
      <div class="col col-12 ps-2 pe-2 pb-2">
        <div class="border border-1 border-dark pb-1">
          <p class="tituloColorMas mb-0 ms-2 mt-1">
            REGISTRO DE CAPACITACIONES
          </p>
          <p class="text-secondary mb-0 ms-2 mt-0">DATOS DE LA CAPACITACION</p>
        </div>
      </div>
    </div>

    <div class="border border-1 pb-2 pt-1 mt-2">
      <div class="row gx-4 gy-3 px-2">
        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">Empresa:</label>
          <label class="ms-2 letras" disabled> {{ empresa }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">Centro de costo:</label>
          <label class="mx-3 letras" disabled> {{ centro }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">SubCentroCosto:</label>
          <label class="mx-3 letras" disabled> {{ subCentro }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">SubSubCentroCosto:</label>
          <label class="mx-3 letras" disabled> {{ subSubCentro }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">Nombre:</label>
          <label class="mx-3 letras" disabled> {{ nombre }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">Apellido Paterno:</label>
          <label class="mx-3 letras" disabled> {{ paterno }}</label>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="color">Apellido Materno:</label>
          <label class="mx-3 letras" disabled> {{ materno }}</label>
        </div>
      </div>
    </div>

    <div class="border border-1 pb-3 mt-2 mx-2 px-2 pt-2 tamaño2">
      <p class="text-center mb-0">INTENTOS PERMITIDOS : 5</p>
      <p class="text-center mb-0">
        LAS CAPACITACIONES SE INICIARON: El {{ respuesta }}
      </p>
      <p class="text-center mb-0">
        METODO DE CALIFICACION: Calificación más alta
      </p>

      <div v-if="preguntas" class="px pt-2">
        <div class="row gx-4 gy-4">
          <div
            v-for="(capacitacion, index) in des[0].titulo"
            :key="index.id"
            class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-12"
          >
            <!-- {{des[0].cabeceraVideo[index]}} -->

            <!-- <p v-if="nota[index] == des[0].cabeceraVideo[index]"></p>   -->
            <div class="shadow-lg p-3 mb-0 bg-white h-100 rounded text-center">
              <p v-if="apagado">cargando....</p>

              <div class="d-flex">
                <div v-if="!apagado" class="my-auto">
                  <!-- <iframe
                    :src="`${des[0].linksVideo[index]}`"
                    class="img-fluid"
                    width="500"
                    height="680"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    ></iframe> -->
                  <a
                    :href="des[0].linksVideo[index]"
                    target="_blank"
                    class="btn btn-ligth border border-1 rounded-0 h-auto p-1"
                  >
                    <div class="pt-2 px-2">
                      <i
                        :class="{
                          'bi bi-youtube text-danger iconoYutu my-0 p-0':
                            !isMobile,
                          'bi bi-youtube text-danger fs-2  p-0': isMobile,
                        }"
                      ></i>

                      <p class="pb-0 ms-2">VISUALIZAR VIDEO</p>
                    </div>
                  </a>
                </div>

                <div class="border border-1 ms-1 py-0 my-auto">
                  <div class="my-auto">
                    <button
                      class="btn btn-success ms-2 mt-4 text-white"
                      v-if="botonPregunta"
                      :disabled="botonPregunta"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        class="bi bi-play-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        />
                        <path
                          d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
                        />
                      </svg>
                      cargando.....
                    </button>

                    <div class="my-0 py-0">
                      <div
                        class="mt-1 p-3"
                        v-if="!botonPregunta"
                        @click="
                          EnviarPreguntas(
                            des[0].cabeceraVideo[index],
                            capacitacion
                          )
                        "
                      >
                        <i
                          :class="{
                            'bi bi-card-checklist text-primary iconoeditar my-0 p-0':
                              !isMobile,
                            'bi bi-card-checklist text-primary fs-2 my-0 py-0':
                              isMobile,
                          }"
                        ></i>

                        <p class="pt-2 realizar ms-2 my-0">REALIZAR EXAMEN</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!isMobile" class="m-2">
                  <h6 class="mt-2 mb-3 tituloColor">
                    {{ capacitacion }}
                  </h6>
                  <button
                    class="btn btn-ligth border border-2 mt-1 tamaño-nota text-dark"
                  >
                    {{ nota[index] }}
                  </button>
                </div>
              </div>

              <div v-if="isMobile" class="m-2">
                <button
                  class="btn btn-ligth border border-2 mt-1 tamaño-nota text-dark"
                >
                  {{ nota[index] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered letras mt-5">
            <thead class="bg-solimano text-white">
              <tr class="text-center">
                <th scope="col">ID</th>
                <th scope="col">TEMA</th>
                <th scope="col">NOTA</th>
                <th scope="col">INTENTO</th>
                <th scope="col">FECHA/HORA</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="info in infex" :key="info.id">
                <td class="text-center">{{ info.idVideo }}</td>
                <td>{{ info.nombre }}</td>
                <td class="text-center">{{ info.nota }}</td>
                <td class="text-center">{{ info.intento }}</td>
                <td class="text-center">{{ info.fecha }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="pt-3 mb-5">
        <div class="pt-3 mb-5">
          <!-- <button v-if="spinner" @click="apreder">aplicar</button> -->
          <div>
            <h3 class="mt-3 titulo2">{{ tituloCapacitacion }}</h3>
          </div>
          <!-- <p v-if="spinner">cargando....</p> -->

          <form action="" @submit.prevent="eventos">
            <div
              class="d-flex"
              v-for="(items, index) in apiPregunta"
              :key="index.id"
            >
              <input
                type="checkbox"
                class="mt-3 mx-2"
                :value="items.idDetVideo"
                @change="preguntasMarcada(items.nroPregunta)"
                v-model="picked1"
                v-if="items.alternativa != 0"
              />

              <label
                class="mt-4 tamaño2"
                :class="{ tamaño: items.alternativa == 0 }"
              >
                {{ items.vidPreguntaDes }}
              </label>
            </div>

            <button
              type="submit"
              class="btn btn-success mt-5"
              :disabled="TiempoDeCarga"
            >
              <i class="bi bi-floppy"></i>
              GUARDAR RESPUESTA
            </button>
          </form>
        </div>
      </div>
    </div>

    <Spinner v-if="cubo" class="w-100"></Spinner>

    <div v-if="mensaje" class="container mt-5 w-100">
      <h3 class="text-center mt-3">No hay videos Disponibles...</h3>
    </div>
  </div>
</template>

<script>
import Spinner from "@/views/SpinnerCarga/Spinner.vue";
import Swal from "sweetalert2";

export default {
  name: "SolimanoLogRegistroCapacitaciones",
  components: {
    Spinner,
  },

  data() {
    return {
      mensaje: false,
      cubo: true,
      TiempoDeCarga: false,
      preguntas: true,
      apagado: true,
      spinner: true,
      items: [],
      titulo: [],
      videosUrl: [],
      pregunta: [],
      cabeceraId: [],
      idNota: [],
      estado: [],
      notas:[],
      tituloCapacitacion: "",

      des: [
        {
          titulo: [],
          linksVideo: [],
          nombreVideo: [],
          numeroPregunta: [],
          cabeceraVideo: [],
          idNotas: [],
          elEstado: [],
          notitas:[]
        },
      ],
      isdisabled: true,
      picked1: [],
      preguntara: [],
      nota: [],
      botonPregunta: true,

      form: {
        idUsuario: "",
        idTrabajdor: "",
        idCabVideo: "",
        vidPreNumero: "",
        detVideo: "",
      },
      apiPregunta: [],
      preguntasResponder: [],
      permisoVisualizador: null,
      numero: [],
      nombre: "",
      paterno: "",
      materno: "",
      empresa: "",
      centro: "",
      subCentro: "",
      subSubCentro: "",
      respuesta: [],
      infex: [],

      idTrabajadores: "",
    };
  },

  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },

  async created() {
    this.idTrabajadores = localStorage.getItem("idTrabajdor");
    this.form.idTrabajdor = localStorage.getItem("idTrabajdor");

    this.cambiarEstadoNavbar();
    this.obtenerDatosContra();
    this.form.idUsuario = localStorage.getItem("userId");
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    await this.axios
      .get(`VidCapacitacion/CapxTrabajador?idTrabajador=${this.idTrabajadores}`)
      .then((r) => {
        console.log(r.data);
        if (r.data.length == 0) {
          this.mensaje = true;
          this.cubo = false;
        }
        this.botonPregunta = false;

        this.items = r.data;
        this.apagado = false;
        for (let itema of r.data) {
          console.log(itema);
          this.titulo.push(itema.nomVideo);
          this.videosUrl.push(itema.videolink);
          this.pregunta.push(itema.numPregunta);
          this.cabeceraId.push(itema.idCabVideo);
          this.idNota.push(itema.idCapnotatrab);
          this.estado.push(itema.estado);
          this.notas.push(itema.nota)

          this.des[0].titulo = this.titulo.filter((item, index) => {
            return this.titulo.indexOf(item) === index;
          });

          this.des[0].linksVideo = this.videosUrl.filter((item, index) => {
            return this.videosUrl.indexOf(item) === index;
          });

          this.des[0].numeroPregunta = this.pregunta.filter((item, index) => {
            return this.pregunta.indexOf(item) === index;
          });

          this.des[0].cabeceraVideo = this.cabeceraId.filter((item, index) => {
            return this.cabeceraId.indexOf(item) === index;
          });

          this.des[0].idNotas = this.idNota.filter((itema, index) => {
            return this.idNota.indexOf(itema) === index;
          });

          this.des[0].elEstado = this.estado.filter((itema, index) => {
            return this.estado.indexOf(itema) == index;
          });

          this.des[0].notitas = this.notas.filter((itema, index) =>{
            return this.notas.indexOf(itema) == index
          })
        }
      });

    this.Notas();
    this.Informacion();
  },

  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    NotaIndividual() {
      // for (let iteracion of this.des[0].cabeceraVideo && this.des[0].idNotas) {
      //
      //
      // }

      console.log(this.des[0].elEstado);
      console.log(this.des[0].elEstado.some((elemento) => elemento === "0"));
      if (this.des[0].elEstado.some((elemento) => elemento === "0")) {
        console.log("videos que mencionana")
      
        for (let index in this.des[0].cabeceraVideo) {

          console.log(this.des[0].cabeceraVideo[index])
          this.axios
            .put(
              `VidCapacitacion/CambioEstadocap?idTrabajador=${this.idTrabajadores}&idVideo=${this.des[0].cabeceraVideo[index]}`
            )
            .then((r) => {
              console.log(r.data);
              if(r.data){
                location.reload(true)
              }
            });
        } 
      }
    },

    Informacion() {
      this.axios
        .get(
          `VidCapacitacion/ListarNotasxTrab?idTrabajador=${this.idTrabajadores}`
        )
        .then((r) => {
          console.log(r.data);
          this.respuesta = r.data[0].fecha;
          this.infex = r.data;

          this.infex.map((r) => {
            console.log(r);
              // this.NotaIndividual();
              console.log(this.des[0].notitas)
              if(this.des[0].notitas > 10){
                this.NotaIndividual();
              }
            
          });

          // this.NotaIndividual()
        });
    },

    obtenerDatosContra() {
      this.axios
        .get(
          `Contrato/ObtenerDatosContratoxTrab?idTrabajador=${this.idTrabajadores}`
        )
        .then((r) => {
          console.log(r.data);
          this.nombre = r.data[0].posNombre;
          this.paterno = r.data[0].posApellidoPaterno;
          this.materno = r.data[0].posApellidoMaterno;
          this.empresa = r.data[0].nomEmpresa;
          this.centro = r.data[0].centroCosto;
          this.subCentro = r.data[0].subCentroCosto;
          this.subSubCentro = r.data[0].subSubCentroCosto;
        });
    },

    async CambiarEstadoCapacitacion() {
      let idTrabajdor = this.form.idTrabajdor;
      let response = await this.axios.put(
        `VidCapacitacion/ModificarCapaxtrab`,
        {
          idTrabajdor,
        }
      );
      console.log(idTrabajdor);
      console.log(response.data);
    },

    async Notas() {
      this.nota = [];
      for (let iteracion of this.des[0].cabeceraVideo) {
        console.log(iteracion);
        await this.axios
          .get(
            `VidCapacitacion/ObtenerNotasxTrab?idTrabajador=${this.idTrabajadores}&idVideo=${iteracion}`
          )
          .then((r) => {
            console.log(r.data);
            this.nota.push(r.data);
          });
        this.CambiarEstadoCapacitacion();
        if (this.nota.length == this.des[0].cabeceraVideo.length) {
          this.cubo = false;
        }
      }
    },

    retroceder() {
      window.history.back();
    },

    EnviarPreguntas(nroPregunta, titulo) {
      this.tituloCapacitacion = titulo;
      this.form.idCabVideo = nroPregunta;
      this.preguntas = false;
      this.axios
        .get(`VidCapacitacion/PreguntasxVideo/${this.form.idCabVideo}`)
        .then((r) => {
          this.apiPregunta = r.data;
          this.spinner = true;
        });
    },

    regreso() {
      this.cubo = true;
      this.Notas();
      this.preguntas = !this.preguntas;
      this.picked1 = [];
      this.preguntara = [];
      this.preguntasResponder = [];
      this.numero = [];
    },

    preguntasMarcada(event) {
      this.preguntara.push(event);
    },

    eventos() {
      this.TiempoDeCarga = true;
      let arreglo1 = this.preguntara.sort(function (a, b) {
        return a - b;
      });

      let arreglo2 = this.picked1.sort(function (a, b) {
        return a - b;
      });

      let array1 = arreglo1.filter((item, index) => {
        return arreglo1.indexOf(item) === index;
      });

      this.form.vidPreNumero = `${array1}`;
      this.form.detVideo = `${arreglo2}`;
      console.log(this.form.vidPreNumero);
      console.log(this.form.detVideo);

      for (let i of this.apiPregunta) {
        this.numero.push(i.nroPregunta);
      }

      let numeroPreguntas = Math.max(...this.numero);
      if (
        arreglo2.length == numeroPreguntas &&
        array1.length == numeroPreguntas
      ) {
        console.log(this.form);
        this.axios
          .post("VidCapacitacion/RegistrarRespuestasxTrab", this.form)
          .then((r) => {
            // this.Informacion()
            console.log(r.data);

            if (r.data == true) {
              // this.Notas()
              setTimeout(() => {
                this.TiempoDeCarga = false;
              }, 5000);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡SE REGISTRARON SUS RESPUESTAS!",
                showConfirmButton: true,
              });
              this.picked1 = [];
              this.numero = [];
              location.reload();
            }
          });
      }

      if (arreglo2.length === 0 || arreglo2.length < numeroPreguntas) {
        Swal.fire({
          title: "¡SE DEBE REALIZAR TODAS LAS PREGUNTAS!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated ani4mate__fadeOutUp",
          },
        });

        this.TiempoDeCarga = false;
      }

      if (
        arreglo2.length > numeroPreguntas ||
        this.form.vidPreNumero.length < numeroPreguntas
      ) {
        Swal.fire({
          title: "¡SE DEBE MARCAR UNO POR PREGUNTA!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        this.TiempoDeCarga = false;
      }
    },
  },
};
</script>

<style scoped>
.titulo {
  font-size: 0.65rem;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.img-fluid {
  height: auto;
}

.bg-solimano {
  background: #0080c8;
}

.preguntas {
  color: #002c5d;
  font-size: 1.05rem;
  font-weight: 600;
}
.tituloColor {
  font-weight: 500;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  color: #002c5d;
  font-size: 0.65rem;
}

.tamaño-nota {
  font-size: 0.65rem;
}

.tamaño {
  font-weight: 600;
  color: rgb(24, 83, 248);
}

.tamaño2 {
  font-size: 0.65rem;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 0.65rem;
}

.letras {
  font-size: 0.65rem;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.iconoYutu {
  font-size: 5.24rem;
  margin: 0;
  padding: 0; /* Establece el relleno a cero */
}

.iconoeditar {
  font-size: 4.7rem;
}

.realizar {
  font-size: 0.95rem;
}
</style>
